// Mouse drag-to-scroll for the cart recommendations row. Touch, trackpad and Shift+wheel scroll it
// natively; delegated on document because the row is re-rendered by the cart morph.
const RECOMMENDATIONS_TRACK = '[data-recommendations-track]';
const RECOMMENDATIONS_PANEL = '#cart-recommendations';
const DRAG_THRESHOLD = 5;

let drag = null;

// The click that ends a drag must not open a product or add it to the cart.
const swallowNextClick = (track) => {
  const controller = new AbortController();
  track.addEventListener(
    'click',
    (event) => {
      event.preventDefault();
      event.stopPropagation();
    },
    { capture: true, once: true, signal: controller.signal },
  );
  setTimeout(() => controller.abort(), 0);
};

document.addEventListener('pointerdown', (event) => {
  if (event.pointerType !== 'mouse' || event.button !== 0) return;
  const track = event.target.closest(RECOMMENDATIONS_TRACK);
  if (!track) return;
  // Stops the press from starting a text selection the browser would then drag instead of scrolling.
  event.preventDefault();
  window.getSelection()?.removeAllRanges();
  drag = { track, startX: event.clientX, startScroll: track.scrollLeft, moved: false };
});

document.addEventListener('pointermove', (event) => {
  if (!drag) return;
  const deltaX = event.clientX - drag.startX;
  if (!drag.moved) {
    if (Math.abs(deltaX) < DRAG_THRESHOLD) return;
    drag.moved = true;
    drag.track.dataset.dragging = '';
  }
  drag.track.scrollLeft = drag.startScroll - deltaX;
});

const endDrag = () => {
  if (!drag) return;
  const { track, moved } = drag;
  drag = null;
  if (!moved) return;
  delete track.dataset.dragging;
  swallowNextClick(track);
};

document.addEventListener('pointerup', endDrag);
document.addEventListener('pointercancel', endDrag);

// Native image, link and selected-text dragging would hijack the gesture; a text drag targets a Text node.
document.addEventListener('dragstart', (event) => {
  const { target } = event;
  const element = target instanceof Element ? target : target.parentElement;
  if (element?.closest(RECOMMENDATIONS_PANEL)) event.preventDefault();
});
